export function BiometryIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M5 2a3 3 0 00-3 3v2.5a1 1 0 002 0V5a1 1 0 011-1h2.5a1 1 0 000-2H5zM16.5 2a1 1 0 100 2H19a1 1 0 011 1v2.5a1 1 0 102 0V5a3 3 0 00-3-3h-2.5zM4 16.5a1 1 0 10-2 0V19a3 3 0 003 3h2.5a1 1 0 100-2H5a1 1 0 01-1-1v-2.5zM22 16.5a1 1 0 10-2 0V19a1 1 0 01-1 1h-2.5a1 1 0 100 2H19a3 3 0 003-3v-2.5zM11.98 5.904a1 1 0 01-.778 1.181C9.63 7.41 8.045 8.619 6.865 10.94a1 1 0 11-1.783-.906c1.376-2.706 3.394-4.429 5.716-4.908a1 1 0 011.181.778zM13.58 6.106a1 1 0 011.314-.525c1.49.638 2.54 1.695 3.146 2.997 1.412 3.029.332 7.087-2.287 10.08a1 1 0 01-1.506-1.317c2.303-2.63 2.944-5.852 1.98-7.919-.396-.85-1.08-1.556-2.12-2.003a1 1 0 01-.526-1.313z"
      ></path>
      <path
        fill="currentColor"
        d="M12 10c.56 0 .967.162 1.227.388.247.215.44.555.461 1.09.046 1.137-.707 3.127-3.395 5.815a1 1 0 101.414 1.414c2.812-2.812 4.06-5.322 3.98-7.31-.041-1.027-.443-1.906-1.148-2.52C13.845 8.276 12.94 8 12 8a1 1 0 100 2zM9.95 11.712a1 1 0 10-1.71-1.038c-.543.894-1.018 1.66-1.845 2.208a1 1 0 001.106 1.667c1.216-.806 1.891-1.92 2.405-2.765l.044-.072z"
      ></path>
      <path
        fill="currentColor"
        d="M12.828 12.562a1 1 0 00-1.655-1.123c-.727 1.07-1.486 2.147-2.178 3.017-.345.435-.664.805-.945 1.092-.293.3-.497.458-.612.522a1 1 0 10.967 1.75c.373-.206.74-.53 1.074-.873.347-.354.713-.782 1.082-1.247.74-.93 1.532-2.056 2.267-3.138z"
      ></path>
    </svg>
  );
}
